/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const DiscussionPromptCircledIcon = /*#__PURE__*/ createSvgIcon(
  'DiscussionPromptCircledIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`}>
            <circle
              cx={10}
              cy={10}
              r={10}
              fill="var(--cds-color-emphasis-neutral-background-weak)"
            />
            <path
              d="M6.5 14l-1.438 1.438c-.197.197-.424.242-.68.132A.588.588 0 014 14.984V5.25c0-.344.122-.638.367-.883S4.907 4 5.25 4h10c.344 0 .638.122.883.367s.367.54.367.883v7.5c0 .344-.122.638-.367.883a1.204 1.204 0 01-.883.367H6.5zm-.531-1.25h9.281v-7.5h-10v8.203l.719-.703zm1.156-1.25h3.75c.177 0 .325-.06.445-.18s.18-.268.18-.445a.605.605 0 00-.18-.445.605.605 0 00-.445-.18h-3.75a.605.605 0 00-.445.18.605.605 0 00-.18.445c0 .177.06.325.18.445s.268.18.445.18zm0-1.875h6.25c.177 0 .325-.06.445-.18S14 9.177 14 9a.605.605 0 00-.18-.445.605.605 0 00-.445-.18h-6.25a.605.605 0 00-.445.18A.605.605 0 006.5 9c0 .177.06.326.18.445.12.12.268.18.445.18zm0-1.875h6.25c.177 0 .325-.06.445-.18s.18-.268.18-.445a.605.605 0 00-.18-.445.605.605 0 00-.445-.18h-6.25a.605.605 0 00-.445.18.605.605 0 00-.18.445c0 .177.06.326.18.445.12.12.268.18.445.18z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default DiscussionPromptCircledIcon;
